import React, { useEffect, useState } from 'react';
import TController from './TController';
import { Box } from '@mui/material';
import { PersitedDatePicker } from '../../../../../../components/common';
import { useQuery } from '../../../../../../hooks/UseQuery';
import axios from 'axios';

interface IProps {
  apiData: any;
  year: number;
}
const DefectWise = ({ apiData, year }: IProps) => {
  return (
    <div>
      <TController apiData={apiData} year={year} />
    </div>
  );
};

export default DefectWise;
